import { render, staticRenderFns } from "./PriceDiff.vue?vue&type=template&id=51756643&scoped=true"
import script from "./PriceDiff.vue?vue&type=script&lang=js"
export * from "./PriceDiff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51756643",
  null
  
)

export default component.exports